export const isChrome = () => typeof chrome !== 'undefined'
export const isEdge = () => window.navigator.userAgent.toLowerCase().includes('edg/') && isChrome()
